import React from 'react'
import propTypes from 'prop-types'
import Icon, {iconNames} from 'components/icon'
import './phone.scss'

const Phone = ({ number, isMobile}) => (
  <a
    className="phone-container"
    href={`tel:${number}`}>
    <Icon name={isMobile ? iconNames.mobile : iconNames.phone} size={14} />
    {number}
  </a>
)

Phone.propTypes = {
  number: propTypes.string,
  isMobile: propTypes.bool,
}

Phone.defaultProps = {
  isMobile: false,
}

export default Phone